<script setup lang="ts">
export interface Crumb {
    label: string
    to?: string
}

withDefaults(
    defineProps<{
        items: Crumb[]
        rootLabel?: string
        rootTo?: string
    }>(),
    { rootLabel: '', rootTo: '/' }
)

defineEmits<{
    (e: 'navigate', to: string): void
}>()
</script>

<template>
    <nav class="flex items-center text-sm min-w-0" aria-label="Breadcrumb">
        <!-- Root crumb — always present, links to dashboard -->
        <button
            v-if="rootLabel"
            type="button"
            class="text-gray-500 hover:text-teal transition-colors uppercase tracking-wider text-xs font-semibold cursor-pointer"
            @click="$emit('navigate', rootTo)"
        >
            {{ rootLabel }}
        </button>
        <template v-for="(item, idx) in items" :key="idx">
            <span class="text-gray-400 opacity-50 mx-1.5 text-[11px] shrink-0">›</span>
            <button
                v-if="item.to && idx < items.length - 1"
                type="button"
                class="text-gray-500 hover:text-teal transition-colors truncate"
                @click="$emit('navigate', item.to)"
            >
                {{ item.label }}
            </button>
            <span
                v-else
                :class="[
                    'truncate',
                    idx === items.length - 1 ? 'text-ink font-bold tracking-tight' : 'text-gray-500'
                ]"
            >
                {{ item.label }}
            </span>
        </template>
    </nav>
</template>
